import useResponsive from "@/hooks/useResponsive.hook";
import { Flex, Tabs } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Transcripts from "./Transcripts";
import VideoPlayer from "./VideoPlyer";

const VideoAndTranscription = ({
  transcriptsData,
  recapRecordings,
}: {
  transcriptsData?: any;
  recapRecordings?: any[];
}) => {
  const { t } = useTranslation();
  const isResponsive = useResponsive();
  const [selectedRecording, setSelectedRecording] = useState<any>(null);

  const hasTranscripts = !!selectedRecording?.transcription?.data?.length;

  const availableRecordings = useMemo(() => {
    return (recapRecordings ?? []).filter((recording) => {
      const isExpired = recording?.expiresAt
        ? new Date(recording.expiresAt) < new Date()
        : false;

      const hasVideo = !!recording?.file && !isExpired;
      const hasTranscript = !!recording?.transcription?.data?.length;

      return hasVideo || hasTranscript;
    });
  }, [recapRecordings]);

  const hasPlayableVideo = availableRecordings.some((recording) => {
    const isExpired = recording?.expiresAt
      ? new Date(recording.expiresAt) < new Date()
      : false;

    return !!recording?.file && !isExpired;
  });

  useEffect(() => {
    if (!availableRecordings.length) {
      setSelectedRecording(null);
      return;
    }

    const hasSelectedRecording = availableRecordings.some(
      (recording) => recording?.id === selectedRecording?.id
    );

    if (!hasSelectedRecording) {
      setSelectedRecording(availableRecordings[0]);
    }
  }, [availableRecordings, selectedRecording?.id]);

  const isExpired = selectedRecording?.expiresAt
    ? new Date(selectedRecording.expiresAt) < new Date()
    : false;

  const onChangeRecording = (recordingId: string) => {
    const recording = availableRecordings.find(
      (item) => item.id === recordingId
    );

    if (recording) {
      setSelectedRecording(recording);
    }
  };

  if (!hasTranscripts && !hasPlayableVideo) {
    return null;
  }
  return (
    <Flex vertical gap={16} className="recap-video-transcription-wrapper">
      {availableRecordings?.length >= 2 && (
        <Tabs
          activeKey={selectedRecording?.id}
          onChange={onChangeRecording}
          items={availableRecordings.map((recording, index) => ({
            key: recording.id,
            label: t("recap.part", { index: index + 1 }),
          }))}
        />
      )}
      <div className="recap-video-transcription-scroll">
        {!hasTranscripts ? (
          <Flex justify="center">
            <VideoPlayer selectedRecording={selectedRecording} />
          </Flex>
        ) : isResponsive || isExpired ? (
          <Flex vertical gap={isExpired ? 12 : 24}>
            <VideoPlayer selectedRecording={selectedRecording} />
            <Transcripts transcripts={selectedRecording?.transcription} />
          </Flex>
        ) : (
          <Flex gap={24}>
            <Flex flex={3}>
              <VideoPlayer selectedRecording={selectedRecording} />
            </Flex>

            <Flex flex={2} className="recap-video-transcription-transcripts">
              <Transcripts transcripts={selectedRecording?.transcription} />
            </Flex>
          </Flex>
        )}
      </div>
    </Flex>
  );
};

export default VideoAndTranscription;
